import Vue from 'vue';
import SightMapNearByBtn from '@/components/SightMapNearByBtn';

export default class NearByControl {
  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._id = 'mb-nearby-control-' + Date.now();
    this._container.id = this._id;
    this._vueComponent = new Vue({
      //pass store to vm
      store: this._map.$vm.$store,
      render: h => h(SightMapNearByBtn)
    }).$mount();
    this._container.appendChild(this._vueComponent.$el);
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._vueComponent = undefined;
    this._map = undefined;
  }
}